module.exports = __webpack_public_path__ + "static/media/metamask-fox.250c3a02.svg";